export type PackSimulator = 'case' | 'backstock';

const PACK_SIMULATOR_TAB_PARAM = 'pack_simulator';

export const getPackSimulatorFromSearch = (search: string): PackSimulator => {
  const simulator = new URLSearchParams(search).get(PACK_SIMULATOR_TAB_PARAM);
  return simulator === 'backstock' ? 'backstock' : 'case';
};

export const setPackSimulatorInSearch = (search: string, simulator: PackSimulator): string => {
  const params = new URLSearchParams(search);
  params.set(PACK_SIMULATOR_TAB_PARAM, simulator);
  return params.toString();
};
